import { useCompany } from './Company.store';

/**
 * Skip hire (PRODUCT-513) is a per-company switch: `crm_enable_skip_hire` on
 * the company payload (`GET company/{hostname}`), next to the other
 * `crm_enable_*` flags. Absent — a backend that predates the field — reads as
 * off, like every other section flag.
 */
export const isSkipHireEnabled = (
  company?: { crm_enable_skip_hire?: boolean } | null
): boolean => !!company?.crm_enable_skip_hire;

/**
 * Whether this tenant has skip hire on. Every skip-hire surface of the portal
 * reads this one hook — the public `/request` door and its login-page link,
 * the `rent_stock` booking handler of the create flow, the Rentals section of
 * the Agreements page and the rental queries behind them — so a tenant with
 * the flag off renders and requests exactly what the portal did before skip
 * hire existed.
 */
export const useSkipHireEnabled = (): boolean => {
  const { data } = useCompany();
  return isSkipHireEnabled(data);
};
